/*
 * @Author: lizhonglin 754760025@qq.com
 * @Date: 2022-04-29 14:14:02
 * @LastEditors: lizhonglin 754760025@qq.com
 * @LastEditTime: 2022-06-07 14:42:37
 * @FilePath: /official-website/src/router/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { createRouter, createWebHashHistory } from 'vue-router'
import { ElMessage } from 'element-plus'
// import HomeView from '../views/HomeView.vue'

const routes = [
    {
        path: '/',
        name: 'home',
        redirect: "home-page",
        component: () => import("@/views/HomeView.vue"),
        children: [
            //首页
            {
                path: "home-page",
                name: "homePage",
                component: () => import("@/views/home/HomePage.vue"),
            },
            //国学AI课
            {
                path: "sinology-ai-course",
                name: "SinologyAICourse",
                component: () => import("@/views/SinologyAICourse/SinologyAICourse.vue"),
            },
            //元宇宙
            {
                path: "metaverse",
                name: "Metaverse",
                component: () => import("@/views/Metaverse/MetaverseHome.vue"),
            },
            //数字藏品
            {
                path: "DigitalCollection",
                name: "DigitalCollection",
                component: () => import("@/views/DigitalCollection/DigitalCollectionHome.vue"),
            },
            //体验课
            {
                path: "experience",
                name: "ExperienceClass",
                component: () => import("@/views/ExperienceClass/ExperienceClassViwe.vue")
            },
            //正式课
            {
                path: "formal-course",
                name: "FormalCourse",
                component: () => import("@/views/FormalCourse/FormalCourseView.vue")
            },
            //漫画
            {
                path: "cartoon",
                name: "Cartoon",
                component: () => import("@/views/Cartoon/IndexView.vue")
            },
            //漫画/表情包详情
            {
                path: "cartoon-detail/:type",
                name: "CartoonDetail",
                component: () => import("@/views/Cartoon/DetailView.vue")
            },
            //课程详情
            {
                path: "course-details/:type",
                name: "CourseDetails",
                meta: {
                    // auth:true
                },
                component: () => import("@/views/CourseDetails/CourseDetailsView.vue")
            },
            //个人中心
            {
                path: "personal-center",
                name: "PersonalCenter",
                redirect: { name: "MyCourseView" },
                meta: {
                    auth: true
                },
                component: () => import("@/views/PersonalCenter/HomeView.vue"),
                children: [
                    {
                        path: "course",
                        name: "MyCourseView",
                        component: () => import("@/views/PersonalCenter/MyCourseView.vue")
                    },
                    {
                        path: "homework",
                        name: "MyHomework",
                        component: () => import("@/views/PersonalCenter/MyHomework.vue")
                    },
                    {
                        path: "videos",
                        name: "MyVideos",
                        component: () => import("@/views/PersonalCenter/MyVideos.vue")
                    }
                ]
            },
            //课程视频播放
            {
                path: "course-broadcast",
                name: "CourseBroadcast",
                meta: {
                    auth: true
                },
                component: () => import("@/views/PersonalCenter/VideoPlayback/IndexView.vue")
            },
            //提交作业
            {
                path: "submit-job",
                name: "SubmitJob",
                meta: {
                    auth: true
                },
                component: () => import("@/views/SubmitJob/SubmitJobView.vue")
            },
            //作业详情
            {
                path: "job-details",
                name: "JobDetails",
                meta: {
                    auth: true
                },
                component: () => import("@/views/SubmitJob/JobDetailsView.vue")
            },

            //课程目录
            {
                path: "course-catalogue",
                name: "CourseCatalogue",
                meta: {
                    auth: true
                },
                component: () => import("@/views/CourseDetails/CourseCatalogueView.vue")
            },
            //直播
            {
                path: 'live-bnroadcast',
                name: "LiveBroadcast",
                meta: {
                    auth: true
                },
                // component:()=> import("@/views/LiveBroadcast/LiveBroadcastView.vue")
                component: () => import("@/views/LiveBroadcast/IndexView.vue")
            },
            //用户协议
            {
                path: "user-agreement",
                name: "UserAgreement",
                component: () => import("@/views/home/UserAgreement.vue")
            },
            //隐私协议
            {
                path: "privac-agreement",
                name: "PrivacyAgreement",
                component: () => import("@/views/home/PrivacyAgreement.vue")
            },
            //关于我们
            {
                path: "about-us",
                name: "AboutUs",
                component: () => import("@/views/home/AboutUs.vue")
            },
            //妙音动态
            {
                path: "dynamic",
                name: "Dynamic",
                component: () => import("@/views/Dynamic/IndexView.vue")
            },
            //妙音动态详情
            {
                path: "dynamic-detail",
                name: "DynamicDetail",
                component: () => import("@/views/Dynamic/DetailView.vue")
            },
            //影音
            {
                path: "video",
                name: "VideoAndAudio",
                component: () => import("@/views/VideoAndAudio/IndexView.vue")
            },
            //影音视频播放
            {
                path: "Video-playback",
                name: "VideoPlayback",
                meta: {
                    auth: true
                },
                component: () => import("@/views/VideoAndAudio/VideoPlayback/IndexView.vue")
            },


        ]

    },
    //了解APP
    {
        path: "/learn-bout-app",
        name: "LearnAboutApp",
        component: () => import("@/views/home/LearnAboutApp.vue")
    },
    //app下载页
    {
        path:"/app-download",
        name:"AppDownload",
        component: ()=> import("@/views/AppDownload/IndexView.vue")
    }
    //   {
    //       path:"*",
    //     //   redirect:"/",
    //   }
]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})
// const routeList=['home','homePage','SinologyAICourse','Metaverse','DigitalCollection','ExperienceClass','FormalCourse','UserAgreement','PrivacyAgreement']
router.beforeEach((to, from, next) => {

    const token = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).token : ''
    if (to.meta.auth) {
        if (token) {
            next()
        } else {
            ElMessage.error("请先登录")
            // console.log(router.currentRoute);
            // console.log(router.currentRoute.value);
            if (!router.currentRoute.value.name) {
                next('/')
            }
            localStorage.clear()
            // sessionStorage.clear()
            // if(to.meta.auth){
            // next()
            // }
        }
    } else {
        // next()
        if (to.name) {
            next()
        } else {
            next('/')
        }
    }
})
export default router
